import Info from "@mui/icons-material/Info"
import Box from "@mui/material/Box"
import FormControl from "@mui/material/FormControl"
import FormLabel from "@mui/material/FormLabel"
import Input from "@mui/material/Input"
import Tooltip from "@mui/material/Tooltip"
import { useField, type FieldComponentProps } from "@w3rone/json-schema-form"
import { FormErrors } from "./FormErrors"

export function SimpleFileField({ name }: FieldComponentProps) {
  const { errors, label, id, description } = useField(name)

  return (
    <FormControl variant={"standard"} error={errors.length > 0} fullWidth>
      {label ? (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <FormLabel htmlFor={id}>{label}</FormLabel>
          {description ? (
            <Tooltip
              title={<div dangerouslySetInnerHTML={{ __html: description }} />}
            >
              <Info />
            </Tooltip>
          ) : null}
        </Box>
      ) : null}

      <FormErrors errors={errors} />

      <Input id={id} name={name} type="file" />
    </FormControl>
  )
}
